import {
    MENU_FLAT_CACHE_KEY,
    buildMenuFlatCachePayload,
    parseMenuFlatCachePayload,
    parseMenuFlatPayload,
} from "./menuFlatCore";
import { adaptMenuFlat } from "./MenuFlatAdapter";

function getStorage(storage) {
    if (storage) return storage;
    if (typeof window !== "undefined" && window.localStorage) return window.localStorage;
    return null;
}

function saveRawMenuFlatCache(rawData, storage) {
    const target = getStorage(storage);
    if (!target) return;

    target.setItem(MENU_FLAT_CACHE_KEY, JSON.stringify(buildMenuFlatCachePayload(rawData)));
}

function readRawMenuFlatCache(storage) {
    const target = getStorage(storage);
    if (!target) return null;

    const cacheValue = target.getItem(MENU_FLAT_CACHE_KEY);
    if (!cacheValue) return null;

    return JSON.parse(cacheValue);
}

export function loadMenuFlatFromCache(storage) {
    const cachedPayload = readRawMenuFlatCache(storage);
    if (!cachedPayload) return null;

    const parsed = parseMenuFlatCachePayload(cachedPayload);
    return adaptMenuFlat(parsed);
}

export async function loadMenuFlat({ api, storage } = {}) {
    const response = await api.get("/menu/courses_flat/");

    if (response?.success === 0) {
        throw new Error(response.error || "Unable to load menu flat");
    }

    const parsed = parseMenuFlatPayload(response?.data);
    saveRawMenuFlatCache(response.data, storage);

    return adaptMenuFlat(parsed);
}

export default {
    load: loadMenuFlat,
    loadFromCache: loadMenuFlatFromCache,
    cacheKey: MENU_FLAT_CACHE_KEY,
};

